<template>
  <b-container>
    <h1 v-if="id == undefined">Criar Plano</h1>
    <h1 v-else>Editar Plano</h1>
    <router-link :to="'/checklist/plans/list/'">
      <b-button size="sm">{{ $t("geral.back") }}</b-button>
    </router-link>
    <b-row>
      <b-col>
        <fade-alert-danger ref="fadeAlertDanger"></fade-alert-danger>
        <success-fade-alert ref="successFadeAlert"></success-fade-alert>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col cols="6">
        <plan-crud :model.sync="model" class="mb-4"></plan-crud>
      </b-col>
    </b-row>
    <!-- <div>{{ model }}</div> -->
    <b-button @click="save"> Salvar </b-button>
  </b-container>
</template>

<script>
export default {
  name: "PlanSave",
  components: {
    PlanCrud: () => import("@/components_rms/System/Plans/PlanCrud.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
  },
  props: {
    id: Number,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Plano salvo com sucesso",
      },
      model: {
        id: 0,
        active: true,
        name: "",
        value: 0.0,
        typeOfPlan: 2,
        typeOfContract: 1,
        franchise: 0,
        blocks: true,
        qntVehicle: 0,
      },
    };
  },
  methods: {
    loadData() {
      this.$apiScheduler
        .get("/paln/getById/" + this.id)
        .then((response) => {
          this.model = response.data;
          let flo = parseFloat(this.model.value).toString();
          const stringValue = (flo / 100).toFixed(2).toString();
          let double = stringValue
            .replace(".", ",")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          this.model.value = double;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    save() {
      this.$apiScheduler
        .post("/plan/save", this.model)
        .then((response) => {
          this.model = response.data;
          console.log(this.id);
          if (this.id == undefined) {
            this.cleanModel();
          }
          this.$refs.successFadeAlert.show();
        })
        .catch((error) => {
          this.$refs.fadeAlertDanger.show();
        });
    },
    cleanModel() {
      this.model.active = true;
      this.model.name = "";
      this.model.value = 0.0;
      this.model.typeOfPlan = 2;
      this.model.typeOfContract = 1;
      this.model.franchise = 0;
    },
  },
  mounted() {
    if (this.id != undefined) {
      this.loadData();
    }
  },
};
</script>
